/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useCraneImpersonation } from "components/profileSettings/useCraneImpersonation";
import { useTenant } from "hooks/settings";
import { useTranslation } from "react-i18next";
import { useListCranesQuery } from "src/store/api/generatedApi";

export const ImpersonateCrane = () => {
  const tenantName = useTenant();
  const { craneToImpersonate, setCraneToImpersonate } = useCraneImpersonation();
  const { data } = useListCranesQuery({ tenantName });
  const { t } = useTranslation();

  return (
    <FormControl sx={{ display: "flex", flex: "1 1 auto", minHeight: 0 }}>
      <RadioGroup
        sx={{
          flex: "1 1 auto",
          minHeight: 0,
          overflowY: "auto",
          flexWrap: "nowrap",
        }}
        value={craneToImpersonate ?? "none"}
        onChange={(e) => {
          if (e.target.value === "none") {
            setCraneToImpersonate(null);
          } else {
            const crane = data?.cranes?.find(
              (crane) => crane.user_uid === e.target.value
            );
            setCraneToImpersonate(crane?.user_uid ?? null);
          }
        }}
      >
        <FormControlLabel
          value="none"
          control={<Radio />}
          label={t("noImpersonation")}
        />
        {data?.cranes?.map((crane) => (
          <FormControlLabel
            key={crane.user_uid}
            value={crane.user_uid}
            control={<Radio />}
            label={crane.name}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
